<template>
  <div class="sorting-select">
    <select
        id="sortingButtons"
        class="sorting-buttons q-form-select q-rounded-3 q-shadow-sm"
        aria-label="Sorting select options"
        @change="sortingStore.updateSorting($event)"
    >
      <option
          v-for="sort in sortingStore.sort"
          :name="sort.id"
          :key="sort.id"
          :selected="sort.id === selectedSort"
      >
        {{ sort.label }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { useSortingStore } from "@/store/SerpPage/SortingStore";
import { onMounted, toRefs } from "vue";

const sortingStore = useSortingStore();
const { selectedSort } = toRefs(sortingStore);

onMounted(() => {
  sortingStore.fetchSortingOptions();
  sortingStore.syncSelectedSortFromUrl({ skipWatcher: true });
});
</script>

<style scoped>
/* --- Kontener z pseudo-elementem jak w akordeonie --- */
.sorting-select{
  position: relative !important;
  display: block !important;
}

/* Grot strzałki — ten sam data-URI, pełna odporność */
.sorting-select::after{
  content: "" !important;
  position: absolute !important;
  inset-inline-end: 1em !important;
  inset-block-start: 50% !important;
  transform: translateY(-50%) !important;

  width: 1.25em !important;
  height: 1.25em !important;
  background-repeat: no-repeat !important;
  background-size: 1.25em !important;
  pointer-events: none !important;
  /* kolor #212529 jak u Ciebie; chcesz currentColor? Daj znać, zrobię wersję z maską */
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
}

/* --- Sam select — wyłączamy natywną strzałkę i robimy miejsce --- */
.sorting-buttons{
  cursor: pointer !important;
  border: 1px solid #f2f2f2 !important;

  /* usuń natywne strzałki */
  appearance: none !important;
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  background: #fff !important;

  /* padding, żeby pseudo-element miał miejsce po prawej */
  padding-inline-end: 2.5em !important; /* 1.25em strzałki + oddech */
  padding-inline-start: .75em !important;

  /* wyrównanie wysokości */
  line-height: 1.25 !important;
  min-height: 2.25rem !important;
  border-radius: .5rem !important;
}

/* focus: subtelny ring + zachowanie Twojego border-color */
.q-form-select:focus{
  border-color: #a4a4a4 !important;
  outline: none !important;
  box-shadow: 0 0 0 2px rgba(32,33,36,.08) !important;
}

/* Edge case: gdy jest obok inny przycisk wewnątrz pola (np. clear X) — przesunięcie grotu */
.sorting-buttons.q-input-with-button + .sorting-select::after{
  inset-inline-end: 3.5em !important;
}

</style>
